import {FormatCurrencyWithoutSymbol} from "../../../../Services/Utils";

export const configTableDailyMonitoring = [
    {name: "fjDate", label: "Tanggal FJ", options: {sort: false}},
    {name: "fjNumber", label: "No FJ", options: {sort: false}},
    {name: "typePayment", label: "Cash/Credit", options: {sort: false}},
    {name: "engineNumber", label: "Nosin", options: {sort: false}},
    {
        name: "orderPrice",
        label: "Harga Beli",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "givenPrice",
        label: "Harga Diberikan",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "discountConsument",
        label: "Diskon Konsumen",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "discountMK",
        label: "Diskon MK",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "jp1Price",
        label: "JP1",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "jp2Price",
        label: "JP2",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "jp3Price",
        label: "JP3",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "subsidyAHM",
        label: "Subsidi AHM",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "subsidyMD",
        label: "Subsidi MD",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "subsidyFincoy",
        label: "Subsidi Fincoy",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "bbnPrice",
        label: "Harga BBN",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "profit",
        label: "Profit",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
];

export const configTableMonthlyMonitoring = [
    {name: "typeName", label: "Nama Tipe", options: {sort: false}},
    {
        name: "totalPriceType.1",
        label: "JAN",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.2",
        label: "FEB",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.3",
        label: "MAR",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.4",
        label: "APR",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.5",
        label: "MAY",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.6",
        label: "JUN",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.7",
        label: "JUL",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.8",
        label: "AUG",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.9",
        label: "SEP",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.10",
        label: "OCT",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.11",
        label: "NOV",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
    {
        name: "totalPriceType.12",
        label: "DEC",
        options: {sort: false, customBodyRender: (val) => FormatCurrencyWithoutSymbol({number: val})}
    },
];

export const sellTypeOptions = [
    {label: "ALL", value: "ALL"},
    {label: "CASH", value: "CASH"},
    {label: "CREDIT", value: "CREDIT"},
];